import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import cx from 'classnames';

import Wildcard from 'assets/images/digital/wildcard.jpg';

import styles from './styles.module.less';

export type WildcardColorPickerProps = {
  color: string;
  setColor: (color: string) => void;
};

const WildcardColorPicker = (props: WildcardColorPickerProps): JSX.Element => {
  const { color, setColor } = props;

  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  return (
    <div className={styles.colorPickerContainer}>
      <div className={styles.wildcardPosition}>
        <div
          className={cx(styles.wildcardIndicator, {
            [styles.wildcardIndicatorActive]: displayColorPicker && !color,
          })}
        >
          <div
            className={styles.wildcardPicker}
            style={
              color
                ? {
                    backgroundImage: 'none',
                    backgroundColor: `#${color}`,
                  }
                : { backgroundImage: `url(${Wildcard})` }
            }
            onClick={() => {
              if (color) {
                setColor(color);
              } else {
                setColor('000000');
              }
              setDisplayColorPicker(true);
            }}
          />
        </div>
        {displayColorPicker && (
          <>
            <div
              className={styles.pickerBackground}
              onClick={() => {
                setDisplayColorPicker(false);
              }}
            />
            <div className={styles.pickerPosition}>
              <SketchPicker
                color={`#${color}`}
                presetColors={[]}
                disableAlpha
                onChangeComplete={c => {
                  if (c) {
                    const newColor = c.hex.split('#')[1];
                    setColor(newColor);
                  }
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WildcardColorPicker;
